import { Pipe, ChangeDetectorRef } from '@angular/core';
import { of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { isNullOrEmpty } from '@awp/core/utils';
import { ContentType } from '../models';
import { ContentPipe } from './content.pipe';
import { ContentProvider } from '../content.provider';
import { ContentParser } from '../content.parser';

@Pipe({ name: 'htmlContent', pure: false })
export class HtmlContentPipe extends ContentPipe {

  constructor(
    contentProvider: ContentProvider,
    contentParser: ContentParser,
    changeDetectorRef: ChangeDetectorRef) {
    super(contentProvider, contentParser, changeDetectorRef);
  }

  updateValue(key: string, interpolateParams?: Object): void {

    // This subscription completes.
    this.contentProvider.get<any>(key, interpolateParams)
      .pipe(
        switchMap(value => {
          if (value != null && value.type === ContentType.Html) {
            if (!isNullOrEmpty(value.content)) {
              return of(this.contentProvider.parserInterpolate(value.content, interpolateParams));
            } else if (!isNullOrEmpty(value.href)) {
              return this.contentProvider.fetchContent(value.href, 'html')
                .pipe(
                  map(response => {
                    return this.contentProvider.parserInterpolate(response, interpolateParams)
                  })
                );
            } else {
              return of(null);
            }
          }
          return of(value);
        })
      )
      .subscribe((value: string) => {
        this.value = value;
        this.lastKey = key;
        this.changeDetectorRef.markForCheck();
      });
  }
}
